<template>
  <v-container fluid>
    <!-- <v-row class="pa-0 ma-0">
      <v-col
        cols="12"
        md="4"
        v-for="(cItem, index) in cloudProvider"
        :key="index"
      >
        <v-card class="secondarygrad fill-height rounded">
          <v-col class="text-right" style="margin-bottom: -18%!important;"
            ><v-chip class="ma-2" color="green" text-color="white">
              BETA
            </v-chip></v-col
          >
          <v-card-text style="height:350px;">
            <div class="my-10" style="width:100%; text-align:center;">
              <img
                :src="getUrl(cItem.imgSrc)"
                :alt="cItem.providerName"
                style="height:60px;"
              />
            </div>
            <br />
            <h3 class="font-weight-regular title text-center mt-4">
              <v-icon>{{ cItem.icon }}</v-icon>
              {{ cItem.providerName }}
            </h3>
            <h4 class="font-weight-thin subtitle text-center">
              {{ cItem.providerDesc }}
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-row class="connect-btn">
              <v-col class="px-8 mb-3 mt-3">
                <v-btn
                  color="primarygrad"
                  class="white--text"
                  block
                  @click="buttonClicked(cItem.route)"
                  >Set Up</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row> -->

    <v-container fluid class="whiteBackGround customBorderRadius">
      <first-page
        :img-src="imgSrc"
        :dialog-name.sync="initialGoPagesDialog"
        :points="points"
        :headline="headline"
      ></first-page>
    </v-container>

    <v-dialog
      v-model="initialGoPagesDialog"
      max-width="500"
      class="customRadiusDialog"
    >
      <v-card>
        <v-card-title class="primarygrad" style="color: white">
          Enter your details
          <v-spacer></v-spacer>
          <!-- <v-btn icon @click="initialGoPagesDialog = false">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn> -->
        </v-card-title>
        <v-card-text class="mt-3">
          <v-text-field
            v-model="name"
            class="my-2"
            label="Name"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="email"
            class="my-2"
            label="Email"
            outlined
            dense
          ></v-text-field>
          <vue-tel-input
            v-model="phone"
            mode="international"
            :valid-characters-only="true"
            :default-country="defaultCountry"
            class="secondary--text my-2"
          ></vue-tel-input>
          <v-select
            v-model="countryCF"
            :items="countries"
            item-text="name"
            item-value="name"
            class="my-2"
            label="Country calling from"
            outlined
            dense
          ></v-select>
          <v-select
            v-model="countryCT"
            :items="countries"
            item-text="name"
            item-value="name"
            class="my-2"
            label="Country calling to"
            outlined
            dense
          ></v-select>
        </v-card-text>
        <v-card-actions class="justify-center mx-2" style="padding-bottom: 8%;">
          <v-btn
            color="#00CF46"
            class="white--text mx-2 text-transform"
            @click="submitMail"
          >
            Submit
          </v-btn>
          <v-btn
            outlined
            color="#00CF46"
            class="text-transform"
            @click="initialGoPagesDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import firstPage from "@/components/firstPage.vue";
import countries from "../js/countries";

export default {
  components: {
    firstPage,
  },
  props: ["item"],
  data() {
    return {
      snackbar: false,
      snackbarMessage: "",
      timeout: 3000,
      customName: "",
      fullURL: "https://enterprise.godial.cc/gopages/",
      firstTimeCampaign: false,
      form: {
        color: "", // Initially no color selected
      },
      website: "",
      pageName: "",
      colors: [
        "red",
        "pink",
        "purple",
        "indigo",
        "blue",
        "green",
        "yellow",
        "amber",
        "brown",
        "black",
      ],
      phone: "",
      name: "",
      email: "",
      countryCF: "",
      countryCT: "",
      countries: countries,
      initialGoPagesDialog: false,
      script: "",
      forms: [], // collection of forms will be stored here
      loader: true, // to wait till the data is ready
      headline: "Effortless Lead Generation with Custom Landing Pages",
      points: [
        "Design Custom Pages in Minutes: No coding required! Build high-converting landing pages with our intuitive drag-and-drop interface.",
        "Capture the Data You Need: Collect the specific information crucial for your sales process with customizable forms.",
        "Seamless Lead Management: Data from GoPages automatically syncs to GoDial lists, ensuring your telecallers have qualified leads ready for contact.",
      ],
    };
  },
  computed: {
    ...mapGetters(["ENDPOINT", "teams", "selectedTeam", "user"]),
    imgSrc() {
      return require("../assets/goimage.svg");
    },
    defaultCountry() {
      const country = countries.find(
        (item) => item.name === this.$store.state.companyDetails.country
      );
      return country ? country.code : "IN";
    },
  },
  async created() {
    // await this.getForms();
    console.log("user: ", this.user);
    console.log("countries: ", this.countries);
    this.name = this.user.name;
    this.phone = this.user.phone;
    this.email = this.user.email;
  },
  methods: {
    async submitMail() {
      console.log("name: ", this.name);
      console.log("email: ", this.email);
      console.log("phone: ", this.phone);
      const data = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        countryCF: this.countryCF,
        countryCT: this.countryCT,
      };
      const response = await this.$http.post(
        `${this.ENDPOINT}/integrations/telecmiInform`,
        data
      );

      if (response.body.status == 200) {
        this.$swal({
          type: "success",
          text: "We've received your inquiry. We will get back to you quickly.",
        });
      } else {
        this.$swal({
          type: "error",
          text: "An error occured! Please try again",
        });
      }
      this.initialGoPagesDialog = false;
    },
  },
};
</script>
<style>
.cs-box {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.image-container img {
  width: auto;
  /* Change this to auto to maintain aspect ratio */
  max-width: 100%;
  /* Prevents the image from exceeding the container width */
  height: auto;
}

.text-transform {
  text-transform: capitalize;
}

.whiteBackGround {
  background-color: white;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-margin {
  margin: 0;
  /* Override any default margin */
}

@media (max-width: 760px) {
  .image-container {
    margin-bottom: 20px;
    /* Adds spacing between the image and text content on mobile */
  }
}

.customRadiusDialog {
  border-radius: 0px !important;
}

.v-application .color-avatar {
  cursor: pointer;
  border: 4px solid transparent;
  /* Maintains layout consistency */
  border-radius: 50%;
  /* Ensures the avatar is round */
  transition: border-color 0.3s;
}

.v-application .active-border {
  border-color: rgb(188 188 188) !important;
  /* Overrides Vuetify theme color */
}

.v-card-title {
  font-size: 1.25rem;
  font-weight: bold;
}

.v-simple-table td {
  vertical-align: middle;
}

.v-img {
  max-width: 50px;
  height: auto;
  display: inline-block;
}

.green-row {
  background-color: #cffede;
  /* Light green color */
}

.v-text-field__details {
  display: none;
}
</style>
